import React from "react";
import ReportTableRowActions, {
  REPORT_TABLE_ACTIONS_COLUMN,
} from "../../common/ReportTable/ReportTableRowActions";
import "./isfReportTable.scss";

export const ISF_REPORT_ACTIONS_COLUMN = REPORT_TABLE_ACTIONS_COLUMN;
export const ISF_REPORT_PINNED_COLUMNS = [ISF_REPORT_ACTIONS_COLUMN];

export const matchTextColumnSearch = (
  row,
  field,
  searchValue,
  skipFields = [],
) => {
  const term = String(searchValue || "").trim().toLowerCase();
  if (!term) return true;
  if (field === ISF_REPORT_ACTIONS_COLUMN || skipFields.includes(field)) {
    return true;
  }
  return String(row[field] ?? "")
    .toLowerCase()
    .includes(term);
};

/** @deprecated Prefer ReportTable `rowActions` prop; kept for ISF screens mid-migration. */
export function IsfReportRowActions({ row, actions = [] }) {
  return <ReportTableRowActions row={row} actions={actions} />;
}
